/* eslint-disable prettier/prettier */
import { useContext } from 'react';
import { Icon, Box, Tooltip, Text } from '@shopify/polaris';
import { NotificationIcon } from '@shopify/polaris-icons';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import './index.css';

import { notificationService } from '#client/services/notificationService.js';

// Env flag: if missing, polling remains enabled by default
const disablePolling = import.meta.env.VITE_DISABLE_POLLING === 'true';
const pollingEnabled = !disablePolling;

export default function NotificationBell() {
    const { currentUser } = useContext(SessionContext);
    const staffId = currentUser?.userId;

    const { data: unreadCount } = useQuery({
        queryKey: ['notifications-count', staffId ?? 'all'],
        queryFn: () => notificationService.fetchUnreadCount(),
        staleTime: pollingEnabled ? 10000 : Infinity,
        refetchOnWindowFocus: pollingEnabled,
        refetchInterval: pollingEnabled ? 30000 : false,
        refetchIntervalInBackground: pollingEnabled,
    });

    const hasUnread = unreadCount > 0;

    return (
        <Tooltip content={hasUnread ? `${unreadCount} unread` : 'Notifications'}>
            <Box position="relative" minWidth="28px">
                <Link to="/notifications" style={{ textDecoration: 'none' }} aria-label="Notifications">
                    <Icon source={NotificationIcon} tone={hasUnread ? 'critical' : undefined} />
                    {hasUnread && (
                        <Box className="badgeCounter">
                            <Text as="span" variant="bodySm" tone="critical-strong">
                                {unreadCount > 99 ? '99+' : unreadCount}
                            </Text>
                        </Box>
                    )}
                </Link>
            </Box>
        </Tooltip>
    );
}
